<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row>
              <!-- <b-col lg="3">
                <label for="datepicker-invalid">Date From</label>
                <b-form-datepicker v-model="DateFrom" id="datepicker-invalid" locale="en-US" size="sm"></b-form-datepicker>
              </b-col>
              <b-col lg="3">
                <label for="datepicker-invalid2">Date To</label>
                <b-form-datepicker v-model="DateTo" id="datepicker-invalid2" locale="en-US" size="sm"></b-form-datepicker>
              </b-col>
              <b-col lg="2" class="mt-4">
                <b-button class="btn-secondary" id="datepicker-btn" @click="getPaymentsByOwnerIDAndDate()">Find</b-button>
              </b-col> -->
              <b-col lg="2" >
                <label class="some-label" for="select-building">Building</label>
                <b-form-select id="select-building" v-model="selectedBuilding" :options="buildingOptions"></b-form-select>
              </b-col>
              <b-col lg="2" >
                <label class="some-label" for="select-status">Status</label>
                <b-form-select id="select-status" v-model="selectedStatus" :options="statusOptions"></b-form-select>
              </b-col>
              <b-col lg="3">
                <label for="datepicker-invalid">Date From</label>
                <b-form-datepicker v-model="DateFrom" id="datepicker-invalid" locale="en-US" size="sm"></b-form-datepicker>
              </b-col>
              <b-col lg="3">
                <label for="datepicker-invalid2">Date To</label>
                <b-form-datepicker v-model="DateTo" id="datepicker-invalid2" locale="en-US" size="sm"></b-form-datepicker>
              </b-col>
              <b-col lg="1" class="mt-4">
                <b-button class="btn-secondary" id="datepicker-btn" @click="getReport()">Find</b-button>
              </b-col>
              <b-col lg="1" class="mt-4">
                <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                  <b-button-group class="mx-1">
                    <b-button style="padding: 5px 6px !important;" @click="getDataForExcel()" title="Export to excel"><b-icon icon="file-earmark-excel-fill"></b-icon></b-button>
                    <b-button style="padding: 5px 6px !important;" @click="getDataForPDF()" title="Export to Pdf"><b-icon icon="file-earmark-pdf-fill"></b-icon></b-button>
                  </b-button-group>
                </b-button-toolbar>
              </b-col>
              </b-row>
              <b-row>
              <b-col lg="8" class="my-1"></b-col>
             <b-col lg="4" class="my-1">
              <label for="datepicker-invalid3"></label>
                  <b-form-group class="mb-0" id="datepicker-invalid3">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <div class="table-container">
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 400px;"
                striped
                responsive
                hover
              >
                <b-thead>
                  <b-tr>
                    <b-th>No.</b-th>
                    <b-th>Building</b-th>
                    <b-th>House</b-th>
                    <b-th>Registered At</b-th>
                    <b-th>Price Option</b-th>
                    <b-th>Currency Type</b-th>
                    <b-th>Price</b-th>
                    <b-th>Monthly Price</b-th>
                    <b-th>Price Including VAT</b-th>
                    <b-th>Status</b-th>
                    <b-th>Tenant</b-th>
                    <b-th>Total Revenue Generated (ETB)</b-th>
                  </b-tr>
                </b-thead>
              <template v-if="spinner">
                  <b-tbody class="text-center">
                    <b-tr >
                        <b-td colspan="9" class="text-center" style="display: table-cell">
                          <b-spinner
                          style="height: 3rem; width: 3rem;"
                            variant="warning"
                          ></b-spinner>
                        </b-td>
                      </b-tr>
                  </b-tbody>
              </template>
              <template v-else>
                <template v-if="filterTable.length === 0" >
                <b-tbody>
                  <b-tr>
                      <b-td colspan="8" class="text-center">Nothing found</b-td>
                      <b-td></b-td>
                    </b-tr>
                    </b-tbody>
                </template>
                <template v-else>
                <b-tbody>
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.ID"
                  >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{item.buildingName}}</b-td>
                      <b-td>{{item.floor}} - {{item.roomNumber}}</b-td>
                      <b-td>{{item.registrationDate}}</b-td>
                      <b-td>{{getOptionPrice(item.priceOption)}}</b-td>
                      <b-td>{{item.currencyType}}</b-td>
                      <b-td>{{numberWithCommas(item.price)}}</b-td>
                      <b-td>{{numberWithCommas(item.monthlyPrice)}}</b-td>
                      <b-td>{{item.includingVat}}</b-td>
                      <b-td>{{item.status}}</b-td>
                      <b-td>{{item.tenantName}}</b-td>
                      <b-td>{{numberWithCommas(item.collectedRevenue)}}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td colspan="8" class="text-right" style="font-weight: bold;">Total Collected Payment (ETB)</b-td>
                    <b-td style="font-weight: bold;">{{numberWithCommas(totalCollectedPayment)}}</b-td>
                  </b-tr>
              </b-tbody>
                </template>
              </template>
            </b-table-simple>
            </div>
            <div class="pagination-container mt-3">
              <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
            </b-row>
            </div>
           </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable';
  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        filter: "",
        DateFrom: "",
        DateTo: "",
        statusOptions:[
          {text: "All", value: "All"},
          {text: "Free", value: "Free"},
          {text: "Rented", value: "Rented"}
        ],
        buildingOptions: [
          {text: "All", value: "All"},
        ],
        selectedBuilding: "All",
        selectedStatus: "All",
        DateFrom: "",
        DateTo: "",
        dataExcel: [],
        priceOptions: [
          {value:"PerSquareMeter", text: "Per Square Meter"},
          {value:"PerMonth", text: "Monthly"}
        ],
        totalCollectedPayment: 0.0,
        spinner: true
      }
    },
    computed: {
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.buildingName.toLowerCase().indexOf(searchString) !== -1 || item.status.toString().toLowerCase().indexOf(searchString) !== -1   || (String(item.floor).toLowerCase() + " - " + item.roomNumber.toLowerCase()).indexOf(searchString) !== -1) {
            return item;
          }
        });
        return searchItems;
      },
    },
     mounted() {
      this.getReport();
      this.getBuildings();
      this.$on("AfterComplete", () => {
        this.getReport();
      });
    },
    methods: {
      getBuildings(){
         this.$store.dispatch('getBuildingsByOwnerID',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
            Array.from(response.data).forEach((value) => {
            this.buildingOptions.push({
              value: value.buildingId,
              text: value.buildingName
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      numberWithCommas(x) {
        if(x !== null && x !== undefined ){
            x= parseFloat(x);
            x = x.toFixed(2);
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else{
          return null;
        }
      },
      getOptionPrice(option){
        if(option != undefined){
          if(option === null) return "";
          else return this.priceOptions.filter(x=>x.value == option)[0].text;
        }else{
          return "";
        }
      },
       getReport(){
        this.spinner = true;
          console.log("DateFrom:",this.DateFrom);
          console.log("DateTo:",this.DateTo);
          console.log("selectedBuilding:",this.selectedBuilding);
          console.log("selectedStatus:",this.selectedStatus);
        if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom === "" && this.DateTo === ""){
          this.$store.dispatch('getReports', {userId: sessionStorage.getItem("ID"), page: 1, line: this.perPage, status: this.selectedStatus})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              this.totalCollectedPayment = response.data.totalCollectedPayment;
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom === "" ){
          this.$store.dispatch('getReportsByBuilding', {userId: sessionStorage.getItem("ID"), page: 1, line: this.perPage, buildingId: this.selectedBuilding})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              this.totalCollectedPayment = response.data.totalCollectedPayment;
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else if(this.selectedStatus === "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
          this.$store.dispatch('getReportsByDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              this.totalCollectedPayment = response.data.totalCollectedPayment;
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom === ""){
          this.$store.dispatch('getReportsByBuildingandStatus', {userId: sessionStorage.getItem("ID"), page: 1, line: this.perPage, status: this.selectedStatus, buildingId: this.selectedBuilding})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              this.totalCollectedPayment = response.data.totalCollectedPayment;
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
          this.$store.dispatch('getReportsByBuildingandDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo, buildingId: this.selectedBuilding})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              this.totalCollectedPayment = response.data.totalCollectedPayment;
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
          this.$store.dispatch('getReportsByStatusandDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo, status: this.selectedStatus})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              this.totalCollectedPayment = response.data.totalCollectedPayment;
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
          this.$store.dispatch('getReportsByBuildingandStatusandDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.perPage, status: this.selectedStatus, buildingId: this.selectedBuilding, startDate: this.DateFrom, endDate: this.DateTo})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              this.totalCollectedPayment = response.data.totalCollectedPayment
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else if(this.selectedStatus === "All" && this.selectedBuilding === "All" && this.DateFrom === "" ){
          console.log("now is now");
           this.$store.dispatch('getReports',  {userId: sessionStorage.getItem("ID"), page: 1, line: this.perPage})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              this.totalCollectedPayment = response.data.totalCollectedPayment
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else{
          console.log("CorrectHere");
          this.$store.dispatch('getReports', {userId: sessionStorage.getItem("ID"), page: 1, line: this.perPage})
          .then(response=>{
              console.log("new", response.data);
              this.items = response.data.houses;
              this.totalCollectedPayment = response.data.totalCollectedPayment
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              //console.log("hereS",error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
      },
      changePage(event, page){
        this.spinner = true;
        if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom === "" && this.DateTo === ""){
          this.$store.dispatch('getReports',  {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, status: this.selectedStatus})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom === "" ){
           this.$store.dispatch('getReportsByBuilding',  {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, buildingId: this.selectedBuilding})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
           this.$store.dispatch('getReportsByDate',  {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom === ""){
           this.$store.dispatch('getReportsByBuildingandStatus',  {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, status: this.selectedStatus, buildingId: this.selectedBuilding})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
           this.$store.dispatch('getReportsByBuildingandDate',  {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo, buildingId: this.selectedBuilding})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
           this.$store.dispatch('getReportsByStatusandDate',  {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo, status: this.selectedStatus})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
           this.$store.dispatch('getReportsByBuildingandStatusandDate',  {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, status: this.selectedStatus, buildingId: this.selectedBuilding, startDate: this.DateFrom, endDate: this.DateTo})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding === "All" && this.DateFrom === "" ){
           this.$store.dispatch('getReports',  {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else{
           this.$store.dispatch('getReports',  {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, status: this.selectedStatus})
          .then(response=>{
              this.items = response.data.houses;
              this.totalCollectedPayment = response.data.totalCollectedPayment
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
      },
      changePerPage(event){
        this.spinner = true;
        if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom === "" && this.DateTo === ""){
          this.$store.dispatch('getReports',  {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, status: this.selectedStatus})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              this.$notifications.notify(
                {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom === "" ){
           this.$store.dispatch('getReportsByBuilding',  {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, buildingId: this.selectedBuilding})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
           this.$store.dispatch('getReportsByDate',  {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom === ""){
           this.$store.dispatch('getReportsByBuildingandStatus',  {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, status: this.selectedStatus, buildingId: this.selectedBuilding})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
           this.$store.dispatch('getReportsByBuildingandDate',  {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo, buildingId: this.selectedBuilding})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
           this.$store.dispatch('getReportsByStatusandDate',  {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, status: this.selectedStatus, startDate: this.DateFrom, endDate: this.DateTo})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
           this.$store.dispatch('getReportsByBuildingandStatusandDate',  {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, status: this.selectedStatus, buildingId: this.selectedBuilding, startDate: this.DateFrom, endDate: this.DateTo})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding === "All" && this.DateFrom === "" ){
           this.$store.dispatch('getReports',  {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.houses;
              this.totalRows = response.data.totalElements;
              // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
        else{
           this.$store.dispatch('getReports',  {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, status: this.selectedStatus})
          .then(response=>{
              this.items = response.data.houses;
              this.totalCollectedPayment = response.data.totalCollectedPayment
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
        }
      },
      async getDataForExcel(){
        this.dataExcel =[];
        if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom === "" ){
          await this.$store.dispatch('getReports', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, status: this.selectedStatus})
          .then( async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
               this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              // this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom === "" ){
          await this.$store.dispatch('getReportsByBuilding', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, buildingId: this.selectedBuilding})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
          await this.$store.dispatch('getReportsByDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, startDate: this.DateFrom, endDate: this.DateTo})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom === ""){
          await this.$store.dispatch('getReportsByBuildingandStatus', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, status: this.selectedStatus, buildingId: this.selectedBuilding})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
          await this.$store.dispatch('getReportsByBuildingandDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, startDate: this.DateFrom, endDate: this.DateTo, buildingId: this.selectedBuilding})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
          await this.$store.dispatch('getReportsByStatusandDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, status: this.selectedStatus, startDate: this.DateFrom, endDate: this.DateTo})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
          await this.$store.dispatch('getReportsByBuildingandStatusandDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, status: this.selectedStatus, buildingId: this.selectedBuilding, startDate: this.DateFrom, endDate: this.DateTo})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
          else if(this.selectedStatus === "All" && this.selectedBuilding === "All" && this.DateFrom === "" ){
          await this.$store.dispatch('getReports', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else{
          console.log("Without filtering data:");
          await this.$store.dispatch('getReports', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, status: this.selectedStatus})
          .then(async response=>{
            console.log("userId",userId);
            console.log("page",page);
            console.log("line",line);
            console.log("else response", response.data);
            if(response.data.houses.length > 0){
              console.log("else response", response.data);
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        if(this.dataExcel.length > 0){
          const filename = 'Report for Houses.csv';
          const csvData = await this.convertToCSV(this.dataExcel);
          const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  
          if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
          } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
              const url = URL.createObjectURL(blob);
              link.setAttribute('href', url);
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        }else{
            this.$notifications.notify(
                {
                  message: "Nothing to export",
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
        }
      },
      async convertToCSV(jsonData) {
        const header = Object.keys(jsonData[0]).join(',');
        const rows = jsonData.map(row => Object.values(row).join(','));
        return `${header}\n${rows.join('\n')}`;
      },
      async getDataForPDF(){
        this.dataExcel =[];
        if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom === "" ){
          await this.$store.dispatch('getReports', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, status: this.selectedStatus})
          .then( async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
               this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              // this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom === "" ){
          await this.$store.dispatch('getReportsByBuilding', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, buildingId: this.selectedBuilding})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
          await this.$store.dispatch('getReportsByDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, startDate: this.DateFrom, endDate: this.DateTo})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom === ""){
          await this.$store.dispatch('getReportsByBuildingandStatus', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, status: this.selectedStatus, buildingId: this.selectedBuilding})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus === "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
          await this.$store.dispatch('getReportsByBuildingandDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, startDate: this.DateFrom, endDate: this.DateTo, buildingId: this.selectedBuilding})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding === "All" && this.DateFrom !== "" ){
          await this.$store.dispatch('getReportsByStatusandDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, status: this.selectedStatus, startDate: this.DateFrom, endDate: this.DateTo})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else if(this.selectedStatus !== "All" && this.selectedBuilding !== "All" && this.DateFrom !== "" ){
          await this.$store.dispatch('getReportsByBuildingandStatusandDate', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows, status: this.selectedStatus, startDate: this.DateFrom, endDate: this.DateTo, buildingId: this.selectedBuilding})
          .then(async response=>{
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
        }
        else{
          await this.$store.dispatch('getReports', {userId: sessionStorage.getItem("ID"), page: 1, line: this.totalRows})
          .then(async response=>{
            console.log("Data",response.data.houses);
            if(response.data.houses.length > 0){
              var index=0;
              Array.from(response.data.houses).forEach(x=>{
                index++;
                this.dataExcel.push({
                  No: index,
                  Building_Name: x.buildingName,
                  Floor: x.floor,
                  Room_Number: x.roomNumber,
                  Price_Option : x.priceOption==="PerSquareMeter"? "Per Square Meter": "Per Month",
                  Currency_Type : x.currencyType,
                  Price : x.price,
                  Monthly_Price : x.monthlyPrice,
                  Price_Including_VAT : x.includingVat,
                  Status: x.status,
                  Registered_At: x.registrationDate,
                  Tenant_Name: x.tenantName,
                  Total_Collected_Revenue: x.collectedRevenue,
                })
              })
              this.totalRows = response.data.totalElements;
            }
          })
          .catch(error=>{
               this.$notify({
                   title: 'Error',
                   text: error.response.data,
                   type: 'error'
               })
              console.log(error);
          })
        }
        if(this.dataExcel.length > 0){
          var pdf = new jsPDF(
            {
              orientation: 'landscape'
            }
          );
          let headers = Object.keys(this.dataExcel[0]);

          // Define rows
          let rows = this.dataExcel.map(obj => Object.values(obj));

          // Add table to PDF
          pdf.autoTable({
            head: [headers],
            body: rows,
            styles: {
              fontSize: 8.5
            },
            headStyles: {
              fillColor: [37, 91, 48],
              textColor: [240, 206, 13],
              fontSize:9
            }
          });

          // Save the PDF
          pdf.save("table.pdf");
          // pdf.text('hello world', 10, 10);
          // pdf.save('Test.pdf');
          // const filename = 'Report for Houses.pdf';
          // // const csvData = await this.convertToCSV(this.dataExcel);
          // const blob = new Blob(this.dataExcel, { type: 'application/pdf;charset=utf-8;' });
  
          // if (navigator.msSaveBlob) { // IE 10+
          //   navigator.msSaveBlob(blob, filename);
          // } else {
          //   const link = document.createElement('a');
          //   if (link.download !== undefined) {
          //     const url = URL.createObjectURL(blob);
          //     link.setAttribute('href', url);
          //     link.setAttribute('download', filename);
          //     document.body.appendChild(link);
          //     link.click();
          //     document.body.removeChild(link);
          //   }
          // }
           
        }else{
          this.$notifications.notify(
          {
            message: "Nothing to export",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          })
        }
      },
      clearData(){
        this.$emit('AfterComplete');
      }
    }
  }
</script>
<style>
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}

/* Table Container Styles */
.table-container {
  position: relative;
  overflow-x: auto;
  margin-bottom: 0;
}

.pagination-container {
  background-color: #fff;
  border-top: 1px solid #dee2e6;
  padding: 15px 0;
  margin-top: 0;
}

/* Responsive Table Adjustments */
@media (max-width: 1200px) {
  .table-container {
    max-height: 350px;
  }
}

@media (max-width: 992px) {
  .table-container {
    max-height: 300px;
  }
}

@media (max-width: 768px) {
  .table-container {
    max-height: 250px;
  }
  
  .pagination-container {
    padding: 10px 0;
  }
}

@media (max-width: 576px) {
  .table-container {
    max-height: 200px;
  }
  
  .pagination-container .form-group label {
    font-size: 0.8rem;
  }
}

/* Ensure proper spacing and prevent overlap */
.card-body {
  padding-bottom: 0 !important;
}

.table-full-width {
  margin-bottom: 0 !important;
}

/* Fix sticky column positioning */
.b-table-sticky-column {
  z-index: 10;
}

.table-container .table {
  margin-bottom: 0;
}
</style>
